import { render, staticRenderFns } from "./levelAttrShow.vue?vue&type=template&id=7cfce390&scoped=true&"
import script from "./levelAttrShow.vue?vue&type=script&lang=ts&"
export * from "./levelAttrShow.vue?vue&type=script&lang=ts&"
import style0 from "./levelAttrShow.vue?vue&type=style&index=0&id=7cfce390&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfce390",
  null
  
)

export default component.exports